<template>
  <a-layout
    :class="{
      'fixed-sider': fixedSider && !isMobile,
      'fixed-header': fixedHeader && !isMobile
    }"
  >
    <drawer v-if="isMobile" :openDrawer="collapsed" @change="onDrawerChange">
      <sider-menu
        :theme="theme"
        :menuData="menuData"
        :collapsed="false"
        :collapsible="false"
        @menuSelect="onMenuSelect"
      />
    </drawer>
    <sider-menu
      :theme="theme"
      :menuData="menuData"
      :collapsed="collapsed"
      :collapsible="true"
      v-else-if="layout === 'side'"
    >
      <a-icon
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggleCollapse"
      />
    </sider-menu>
    <a-layout class="fix-flex-auto">
      <global-header :menuData="menuData"/>
      <a-layout-content>
        <slot></slot>
      </a-layout-content>
      <a-layout-footer>
        <global-footer
          style="display:none;"
          :link-list="linkList"
          :copyright="copyright"
        />
      </a-layout-footer>
    </a-layout>
    <drawer
      v-if="allowSetting"
      :open-drawer="showSetting"
      placement="right"
      @change="onSettingDrawerChange"
    >
      <div class="setting" slot="handler">
        <a-icon :type="showSetting ? 'close' : 'setting'"/>
      </div>
      <setting/>
    </drawer>
    <global-load></global-load>
  </a-layout>
</template>

<script>
  import GlobalHeader from './GlobalHeader';
  import GlobalFooter from './GlobalFooter';
  import GlobalLoad from './GlobalLoad';
  import Drawer from '../components/common/Drawer';
  import SiderMenu from '../components/menu/SiderMenu';
  import Setting from '../components/setting/Setting';
  import {mapState} from 'vuex';

  export default {
    name: 'GlobalLayout',
    components: {
      Setting,
      SiderMenu,
      Drawer,
      GlobalFooter,
      GlobalHeader,
      GlobalLoad
    },
    data() {
      return {
        collapsed: false,
        menuData: [],
        routeData: [],
        showSetting: false
      };
    },

    computed: {
      ...mapState({
        allowSetting: state => state.setting.allowSetting,

        isMobile: state => state.setting.isMobile,
        isSmallLaptop: state => state.setting.isSmallLaptop,
        theme: state => state.setting.theme,
        layout: state => state.setting.layout,
        fixedSider: state => state.setting.fixedSider,
        fixedHeader: state => state.setting.fixedHeader,
        linkList: state => state.setting.footerLinks,
        copyright: state => state.setting.copyright
      }),
      miniSidemenu() {
        return !this.isMobile && this.isSmallLaptop;
      }
    },

    created() {
      this.initMenuData();
      this.setMiniSidemenu();
    },

    methods: {
      async initMenuData() {
        this.menuData = this.$router.options.routes.find(item => item.path === '/').children;

        /***
         * 菜单权限判断
         *
         */
        // 判断当前系统等级和是否教育局管理员
        let {systemLevel, adminLevel} = this.$store.state;
        console.log("[-> GlobalLayout]", "[systemLevel]::", systemLevel, "[adminLevel]::", adminLevel);
        // Title不一样
        if(systemLevel === "kinder") {
          this.$store.state.setting.systemName = "幼儿园报名系统";
        } else {
          this.$store.state.setting.systemName = "随迁子女报名系统";
        }
        // 验证是否有显示菜单的权限
        for (let i=0; i<this.menuData.length; i++) {
          if (this.menuData[i].meta) {
            let metaSystemLevel = this.menuData[i].meta.systemLevel;
            let metaAdminLevel = this.menuData[i].meta.adminLevel;
            // console.log("[-> GlobalLayout] router.meta", this.menuData[i].name, "[metaSystemLevel]::", metaSystemLevel, "[metaAdminLevel]::", metaAdminLevel);
            // 判断systemLevel
            if(metaSystemLevel) {
              if(systemLevel === metaSystemLevel){
                // console.log("-> item menu ::show:: by systemLevel", this.menuData[i].name);
                this.menuData[i].invisible = false;
              } else {
                // console.log("-> item menu ::hide:: by systemLevel", this.menuData[i].name);
                this.menuData[i].invisible = true;
                break;
              }
            }
            // 判断adminLevel
            if(metaAdminLevel) {
              if(adminLevel === metaAdminLevel || (metaAdminLevel.split('|').length>1 ? (metaAdminLevel.split('|')[0]===adminLevel || metaAdminLevel.split('|')[1]===adminLevel) : false)){
                // console.log("-> item menu ::show:: by adminLevel", this.menuData[i].name);
                this.menuData[i].invisible = false;
              } else {
                // console.log("-> item menu ::hide:: by adminLevel", this.menuData[i].name);
                this.menuData[i].invisible = true;
              }
            }
          }
        }
      },

      toggleCollapse() {
        this.collapsed = !this.collapsed;
      },

      onDrawerChange(show) {
        this.collapsed = show;
      },

      onMenuSelect() {
        this.toggleCollapse();
      },

      onSettingDrawerChange(val) {
        this.showSetting = val;
      },

      setMiniSidemenu() {
        if (this.miniSidemenu) {
          this.collapsed = true;
        } else {
          this.collapsed = false;
        }
      }
    },

    watch: {
      miniSidemenu() {
        this.setMiniSidemenu();
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .fix-flex-auto
    flex 1 1 auto

  .setting
    background-color #1890ff
    color #fff
    border-radius 5px 0 0 5px
    line-height 40px
    font-size 22px
    width 40px
    height 40px
    box-shadow -2px 0 8px rgba(0, 0, 0, 0.15)

  .trigger
    position absolute
    right -68px
    top 0
    font-size 20px
    line-height 64px
    padding 0 24px
    margin-left -24px
    cursor pointer
    transition color 0.3s
    background rgba(#fff, 0.8)
    border-radius 0 8px 8px 0
    box-shadow -1px 1px 4px rgba(0, 21, 41, 0.08)
    &:hover
      color #1890ff
      background #fff
</style>
